import actions from './actions';

const initState = {
    loader: true,
    error: '',
    salesSettlementDetails: [],
    openInvoiceLoader: true,
    openInvoiceList: '',
    openInvoiceData: '',
    openPaymentLoader: true,
    openPaymentList: '',
    openPaymentData: '',
    closeInvoiceLoader: true,
    closeInvoiceDetails: [],
    closePaymentLoader: true,
    closePaymentDetails: [],
};

export default function salesSettlementReducer(state = initState, action) {
    switch (action.type) {
        case actions.SALES_SETTLEMENT_DETAILS_START: {
            return {
                ...state,
                loader: true,
            };
        }
        case actions.SALES_SETTLEMENT_DETAILS_SUCCESS: {
            return {
                ...state,
                loader: false,
                salesSettlementDetails: action.payload,
            };
        }
        case actions.SALES_SETTLEMENT_DETAILS_FAILURE: {
            return {
                ...state,
                openInvoiceLoader: false,
                error: action.message,
            };
        }
        case actions.OPEN_INVOICE_DETAILS_START: {
            return {
                ...state,
                openInvoiceLoader: true,
            };
        }
        case actions.OPEN_INVOICE_DETAILS_SUCCESS: {
            if ((action.data.length === 0 && action.skip === 0) || action.skip === 0) {
                return {
                    ...state,
                    openInvoiceLoader: false,
                    openInvoiceList: action.data,
                    openInvoiceData: action.data,
                }
            } else if (action.data.length === 0) {
                return {
                    ...state,
                    openInvoiceData: action.data,
                    openInvoiceLoader: true
                }
            } else {
                return {
                    ...state,
                    openInvoiceList: [
                        ...state.openInvoiceList,
                        ...action.data
                    ],
                    openInvoiceData: action.data,
                    openInvoiceLoader: false
                }
            }
        }
        case actions.OPEN_INVOICE_DETAILS_FAILURE: {
            return {
                ...state,
                openInvoiceLoader: false,
                error: action.message,
            };
        }
        case actions.OPEN_PAYMENT_DETAILS_START: {
            return {
                ...state,
                openPaymentLoader: true
            };
        }
        case actions.OPEN_PAYMENT_DETAILS_SUCCESS: {
            if ((action.data.length === 0 && action.skip === 0) || action.skip === 0) {
                return {
                    ...state,
                    openPaymentLoader: false,
                    openPaymentList: action.data,
                    openPaymentData: action.data,
                }
            } else if (action.data.length === 0) {
                return {
                    ...state,
                    openPaymentData: action.data,
                    openPaymentLoader: true
                }
            } else {
                return {
                    ...state,
                    openPaymentList: [
                        ...state.openPaymentList,
                        ...action.data
                    ],
                    openPaymentData: action.data,
                    openPaymentLoader: false
                }
            }
        }
        case actions.OPEN_PAYMENT_DETAILS_FAILURE: {
            return {
                ...state,
                openPaymentLoader: false,
                error: action.message,
            };
        }
        case actions.CLOSE_INVOICE_DETAILS_START: {
            return {
                ...state,
                closeInvoiceLoader: true,
                error: action.message,
            };
        }
        case actions.CLOSE_INVOICE_DETAILS_SUCCESS: {
            return {
                ...state,
                closeInvoiceLoader: false,
                closeInvoiceDetails: action.payload
            };
        }
        case actions.CLOSE_INVOICE_DETAILS_FAILURE: {
            return {
                ...state,
                closeInvoiceLoader: false,
                error: action.message,
            };
        }
        case actions.CLOSE_PAYMENT_DETAILS_START: {
            return {
                ...state,
                closePaymentLoader: true,
                error: action.message,
            };
        }
        case actions.CLOSE_PAYMENT_DETAILS_SUCCESS: {
            return {
                ...state,
                closePaymentLoader: false,
                closePaymentDetails: action.payload,
            };
        }
        case actions.CLOSE_PAYMENT_DETAILS_FAILURE: {
            return {
                ...state,
                closePaymentLoader: false,
                error: action.message,
            };
        }
        case actions.CLEAR_REPORT_DETAILS_START: {
            return {
                ...state,
            };
        }
        case actions.CLEAR_REPORT_DETAILS_SUCCESS: {
            return {
                ...state,
                loader: true
            };
        }
        default:
            return state;
    }
}